module.exports = __webpack_public_path__ + "img/Frame-13.e2fe9a89.svg";